import {Checkbox} from "@/components/ui/checkbox";
import {useController} from "react-hook-form";
import {ComponentProps, ReactNode} from "react";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";

interface CheckboxFieldProps {
    name: string
    label?: string | ReactNode
    hideError?: boolean
    containerClassName?: ComponentProps<'div'>["className"]
}

export function CheckboxField({name, hideError, label, containerClassName}: CheckboxFieldProps) {
    const {field} = useController({name})
    return (
        <FormField name={name}>
            <FormItem className={containerClassName}>
                <FormControl>
                    <div className="flex items-center space-x-2">
                        <Checkbox
                            id={name}
                            checked={field.value}
                            onCheckedChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={field.disabled}
                            ref={field.ref}
                        />
                        {label && <FormLabel>
                            {label}
                        </FormLabel>}
                    </div>
                </FormControl>
                {!hideError! && <FormMessage/>}
            </FormItem>
        </FormField>
    )
}

CheckboxField.displayName = "CheckboxField";
